import React from 'react';
import MenuWithLogin from '../templates/MenuWithLogin'
import VideoList from '../components/container/VideoList'
import HomeIntro from '../components/presentational/HomeIntro'

export default function Home(props) {
  return (
    <MenuWithLogin title='Online CLE' size="lg" loggedIn={props.loggedIn} setLoggedIn={props.setLoggedIn} handleLoginBoxOpen={props.handleLoginBoxOpen} handleSignOut={props.handleSignOut}>
        <HomeIntro />
        <VideoList></VideoList>
    </MenuWithLogin>
  );
}